import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CartAddEntrySuccessEvent, CartRemoveEntrySuccessEvent } from '@spartacus/cart/base/root';
import { provideConfig } from '@spartacus/core';
import {
  CategoryPageResultsEvent,
  HomePageEvent,
  NavigationEvent,
  SearchPageResultsEvent
} from '@spartacus/storefront';
import { AepModule } from '@spartacus/tracking/tms/aep';
import { BaseTmsModule, TmsConfig } from '@spartacus/tracking/tms/core';
import { GtmModule } from '@spartacus/tracking/tms/gtm';
import { environment } from '../../../../environments/environment';
import { CustomCartEventModule } from './custom-events/cart/custom-cart-event.module';
import {
  CustomCartAddEntrySuccessEvent,
  CustomCartRemoveEntrySuccessEvent,
  CustomCartUpdateEntrySuccessEvent,
  CustomViewCartSuccessEvent,
} from './custom-events/cart/custom-cart.events';
import {
  CustomCheckoutStepsEventModule
} from './custom-events/checkout/checkout-steps/custom-checkout-steps-event.module';
import {
  CustomCheckoutAddPaymentInfoEvent,
  CustomCheckoutAddShippingInfoEvent,
  CustomCheckoutBeginEvent,
  CustomCheckoutDeliveryModeEvent,
  CustomCheckoutPaymentModeEvent,
  CustomCheckoutStepsEvent,
} from './custom-events/checkout/checkout-steps/custom-checkout-steps.events';
import {
  CustomCheckoutEffects
} from './custom-events/checkout/checkout-steps/store/effects/custom-checkout-steps-events.effect';
import { CustomPromotionEvent } from "./custom-events/checkout/cms/custom-cms-events";
import { CustomCheckoutEventModule } from './custom-events/checkout/place-order/custom-checkout-event.module';
import { CustomOrderPlacedEvent } from './custom-events/checkout/place-order/custom-custom-checkout.events';
import { CustomCleanEcommerceEvent } from "./custom-events/common/custom-common.event";
import { CustomNavigationEventModule } from './custom-events/navigation/custom-navigation-event.module';
import { CustomNavigationEvent, GeneralUserNavigatorEvent } from './custom-events/navigation/custom-navigation.event';
import { CustomProductPageEventModule } from './custom-events/product/custom-product-page-event.module';
import {
  CustomProductDetailsPageEvent,
  CustomProductImpressionResultsEvent
} from './custom-events/product/custom-product-page.events';
import { CustomUserEventModule } from "./custom-events/user/custom-user-event.module";
import { CustomUserEvent } from "./custom-events/user/custom-user.event";

@NgModule({
  imports: [
    BaseTmsModule.forRoot(),
    GtmModule,
    AepModule,
    CustomNavigationEventModule,
    CustomCartEventModule,
    CustomCheckoutEventModule,
    CustomCheckoutStepsEventModule,
    CustomProductPageEventModule,
    EffectsModule.forFeature([
      CustomCheckoutEffects,
    ]),
    CustomUserEventModule
  ],
  providers: [
    provideConfig({
      tagManager: {
        gtm: {
          gtmId: environment?.gtmId,
          events: [
            /*Cleaner event*/
            CustomCleanEcommerceEvent,
            /*Pages Events*/
            GeneralUserNavigatorEvent,
            HomePageEvent,
            CustomNavigationEvent,
            // PageEvent,
            SearchPageResultsEvent,
            CategoryPageResultsEvent,
            CustomProductImpressionResultsEvent,
            CustomProductDetailsPageEvent,
            // SearchBoxSuggestionSelectedEvent,
            // SearchBoxProductSelectedEvent,

            /*Cart Events*/
            CustomCartAddEntrySuccessEvent,
            CustomCartUpdateEntrySuccessEvent,
            CustomCartRemoveEntrySuccessEvent,
            CustomViewCartSuccessEvent,

            /* Checkout Steps Events */
            CustomCheckoutBeginEvent,
            CustomCheckoutAddShippingInfoEvent,
            CustomCheckoutAddPaymentInfoEvent,
            CustomCheckoutStepsEvent,
            CustomCheckoutDeliveryModeEvent,
            CustomCheckoutPaymentModeEvent,
            /*Place order Events*/
            CustomOrderPlacedEvent,
            NavigationEvent,
            CartAddEntrySuccessEvent,

            /* User Events */
            CustomUserEvent,
            /* CMS events */
            CustomPromotionEvent
          ],
          debug: !environment.production,
        },
        aep: {
          events: [
            NavigationEvent,
            CartRemoveEntrySuccessEvent
          ],
        },
      },
    } as TmsConfig),
  ],
})
export class TagManagerFeatureModule {
}
